const getInitials = (name: string) => {
  if (!name) return ''
  const nameArr = name.split(' ')
  const initialLastName = nameArr[nameArr.length - 1][0]

  return `${nameArr[0]} ${initialLastName}.`
}

export { getInitials }
